module.exports = __webpack_public_path__ + "static/media/14.c76cf6dc.svg";